import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Trash2, Minimize, Maximize } from 'lucide-react';
import Button from '../../components/UI/Button';
import Card from '../../components/UI/Card';
import CopyButton from '../../components/UI/CopyButton';
import './JsonBeautifier.css';

const JsonBeautifier = () => {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [error, setError] = useState(null);

    const handleFormat = () => {
        try {
            if (!input.trim()) return;
            const parsed = JSON.parse(input);
            setOutput(JSON.stringify(parsed, null, 2));
            setError(null);
        } catch (err) {
            setError('Invalid JSON: ' + err.message);
            setOutput('');
        }
    };

    const handleMinify = () => {
        try {
            if (!input.trim()) return;
            const parsed = JSON.parse(input);
            setOutput(JSON.stringify(parsed));
            setError(null);
        } catch (err) {
            setError('Invalid JSON: ' + err.message);
            setOutput('');
        }
    };

    const handleClear = () => {
        setInput('');
        setOutput('');
        setError(null);
    };

    return (
        <div className="tool-page container">
            <Helmet>
                <title>JSON Beautifier - Format & Validate JSON | OnlineToolSphere</title>
                <meta name="description" content="Free online JSON beautifier and validator. Format, minify, and fix your JSON data instantly. Secure client-side processing." />
                <meta property="og:title" content="JSON Beautifier - Format & Validate JSON | OnlineToolSphere" />
                <meta property="og:description" content="Free online JSON beautifier and validator. Format, minify, and fix your JSON data instantly." />
                <meta property="og:url" content="https://onlinetoolsphere.com/tools/json-beautifier/" />
                <meta name="twitter:title" content="JSON Beautifier - Format & Validate JSON | OnlineToolSphere" />
                <meta name="twitter:description" content="Free online JSON beautifier and validator. Format, minify, and fix your JSON data instantly." />
            </Helmet>
            <div className="tool-header">
                <h1 className="text-gradient">JSON Beautifier</h1>
                <p className="tool-subtitle">Format, validate, and minify your JSON data.</p>
            </div>

            <div className="tool-actions">
                <Button onClick={handleFormat}><Maximize size={16} style={{ marginRight: '0.5rem' }} /> Beautify</Button>
                <Button variant="secondary" onClick={handleMinify}><Minimize size={16} style={{ marginRight: '0.5rem' }} /> Minify</Button>
                <Button variant="secondary" onClick={handleClear}><Trash2 size={16} style={{ marginRight: '0.5rem' }} /> Clear</Button>
            </div>

            <div className="editor-grid">
                <div className="editor-pane">
                    <div className="pane-header">Input</div>
                    <textarea
                        className={`code-editor ${error ? 'error' : ''}`}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Paste your JSON here..."
                        spellCheck="false"
                    />
                    {error && <div className="error-message">{error}</div>}
                </div>

                <div className="editor-pane">
                    <div className="pane-header">
                        Output
                        {output && (
                            <CopyButton text={output} iconOnly={true} />
                        )}
                    </div>
                    <textarea
                        className="code-editor"
                        value={output}
                        readOnly
                        placeholder="Result will appear here..."
                        spellCheck="false"
                    />
                </div>
            </div>
        </div>
    );
};

export default JsonBeautifier;
